import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-settings-block',
  templateUrl: './settings-block.component.html',
  styleUrls: ['./settings-block.component.scss']
})
export class SettingsBlockComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
